import { RootState } from '../store/configureStore';

export const getAvailableProductTypes = (state: RootState) => state?.availableProductType?.productAvailableTypes;

export const isFetchinAvailableProductTypes = (state: RootState) =>
  state?.availableProductType?.isFetchingProductAvailableTypes;

export const didFetchingAvailableProductTypesFailed = (state: RootState) =>
  state?.availableProductType?.fetchingProductAvailableTypesFailed;
